<template>
  <section>
    <div class="section_title">
      <h1 class="">よくあるご質問</h1>
    </div>
    <h3 class="mt-5">ご注文について</h3>
    <dl class="list-qa">
      <dt v-on:click="openInfo('1')" :class="{'is-active': isActive[1]}">（初回の）注文方法を教えてください。</dt>
      <dd v-show="isActive[1]">FAX、郵送、会員サイト（ホームページ）でのご注文が可能です。<br>※「会員登録申込書兼商品注文書」でのご注文となります。</dd>
      <dt v-on:click="openInfo('2')" :class="{'is-active': isActive[2]}">（2回目以降の）注文方法を教えてください。</dt>
      <dd v-show="isActive[2]">
        FAX、電話、会員サイト（ホームページ）でご注文いただけます。<br>
        電話：営業日9時から16時<br>
        FAX・会員サイト（ホームページ）：24時間 年中無休<br>
        （いずれも営業日16時以降のご注文は翌営業日の出荷になります）
      </dd>
      <dt v-on:click="openInfo('3')" :class="{'is-active': isActive[3]}">ツール品のみの注文はできますか？</dt>
      <dd v-show="isActive[3]">ツール品のみでのご注文はできません。通常商品1個以上のご注文と合わせてお願いいたします。</dd>
      <dt v-on:click="openInfo('4')" :class="{'is-active': isActive[4]}">支払方法を教えてください。</dt>
      <dd v-show="isActive[4]">代金引換、銀行振込（事前のお振込）でお支払いいただけます。<br>来社購入される場合は、現金でお支払いいただけます。<br>当ホームページの会員サイトからご購入いただく場合は、クレジットカードでもお支払いいただけます。<br>※クレジットカードでのご購入は1回払いのみとなります。<br>※ご本人様名義のクレジットカードをご利用ください。</dd>
      <dt v-on:click="openInfo('5')" :class="{'is-active': isActive[5]}">代金引換手数料について教えてください。</dt>
      <dd v-show="isActive[5]">¥300が必要です。<br>新規入会時のご購入のみ無料です。</dd>
      <dt v-on:click="openInfo('6')" :class="{'is-active': isActive[6]}">送料はかかりますか？</dt>
      <dd v-show="isActive[6]">1回のご注文（ツール品を含む）で1万円（税込）以上の場合、無料です。<br>1万円未満の場合は全国一律700円の配送費をいただきます。</dd>
      <dt v-on:click="openInfo('7')" :class="{'is-active': isActive[7]}">自宅以外に商品を送ってもらえますか？</dt>
      <dd v-show="isActive[7]">ご自宅、別送先にもお送りできます。別送先をご指定いただく場合には、別送先の住所をご記入ください。<br>※商品のお届けは、日本国内に限らせていただきます。</dd>
      <dt v-on:click="openInfo('8')" :class="{'is-active': isActive[8]}">発送のタイミングを教えてください。</dt>
      <dd v-show="isActive[8]">営業日の16:00までに受付されたご注文分については原則として宅配便により当日出荷、営業日16:00時以降もしくは土日祝日に到着したご注文分は翌営業日出荷となります。<br>ただし、初回ご注文の場合は、入会審査などの手続き上、ご注文受付日の翌営業日以降の出荷となることがあります。</dd>
    </dl>
    <h3 class="mt-5 pt-5">ポイントについて</h3>
      <dl class="list-qa">
        <dt v-on:click="openInfo('9')" :class="{'is-active': isActive[9]}">ポイントについて教えてください。</dt>
        <dd v-show="isActive[9]">商品及びツール品を購入することでそれぞれに設定されているポイントが付与されます。<br>貯まったポイントは、次回の買い物で1ポイント＝1円として商品及びツール品のご購入にご使用していただけます。</dd>
        <dt v-on:click="openInfo('10')" :class="{'is-active': isActive[10]}">ポイントの還元率を教えてください</dt>
        <dd v-show="isActive[10]">原則として商品・ツール品それぞれの購入代金の1％相当のポイントが設定されています。<br>また、送料や代金引換手数料にはポイントの還元はございません。<br>※還元率は商品によって異なります。</dd>
        <dt v-on:click="openInfo('11')" :class="{'is-active': isActive[11]}">ポイントはどのタイミングで付与されますか。</dt>
        <dd v-show="isActive[11]">出荷確定後は仮ポイントとして付与されますが、仮ポイントの状態ではご使用できません。<br>出荷日の深夜に仮ポイントは使用できるポイントに変更されます。</dd>
        <dt v-on:click="openInfo('12')" :class="{'is-active': isActive[12]}">エコポイントとは何ですか？</dt>
        <dd v-show="isActive[12]">エコ対象商品をご購入していただく事で、より多くのポイント付与させていただきます。</dd>
        <dt v-on:click="openInfo('13')" :class="{'is-active': isActive[13]}">送料や代金引換手数料にポイントは使えますか？</dt>
        <dd v-show="isActive[13]">送料や代金引換手数料にはポイントの利用はできません。</dd>
        <dt v-on:click="openInfo('14')" :class="{'is-active': isActive[14]}">ポイントの有効期限を教えてください。</dt>
        <dd v-show="isActive[14]">ポイント付与日の翌年度の3月31日16:00までとなります。</dd>
      </dl>
    <h3 class="mt-5 pt-5">支払通知書WEB化について</h3>
    <dl class="list-qa">
      <dt v-on:click="openInfo('50')" :class="{'is-active': isActive[50]}">Web明細はいつから始まっていますか？</dt>
      <dd v-show="isActive[50]">Web明細は2025年5月から閲覧できるようになっています。完全なWeb明細移行（郵送の有料化）は2025年10月からです。</dd>
      <dt v-on:click="openInfo('51')" :class="{'is-active': isActive[51]}">Web明細を見るには申込みが必要ですか？</dt>
      <dd v-show="isActive[51]">申込みは不要です。会員サイトをご利用の方は自動的にWeb明細となります。</dd>
      <dt v-on:click="openInfo('52')" :class="{'is-active': isActive[52]}">Web明細はどこで、どのように見られますか？</dt>
      <dd v-show="isActive[52]">会員サイトにログイン後、メニューの「ボーナス明細」から閲覧できます。パソコン、スマートフォンどちらからもご利用可能です。</dd>
      <dt v-on:click="openInfo('53')" :class="{'is-active': isActive[53]}">会員サイトに登録していない場合はどうすればよいですか？</dt>
      <dd v-show="isActive[53]">Webで明細をご覧いただくには、会員サイトのご利用登録が必要です。お手数ですが、事前にご登録をお願いいたします。</dd>
      <dt v-on:click="openInfo('54')" :class="{'is-active': isActive[54]}">なぜWeb明細に切り替わるのですか？</dt>
      <dd v-show="isActive[54]">紙の使用量削減による環境負荷軽減を目的としております。</dd>
      <dt v-on:click="openInfo('55')" :class="{'is-active': isActive[55]}">過去のWeb明細も見られますか？</dt>
      <dd v-show="isActive[55]">はい、過去５年分閲覧可能です。</dd>
      <dt v-on:click="openInfo('56')" :class="{'is-active': isActive[56]}">ウィッグや化粧品の明細もWebで確認できますか？</dt>
      <dd v-show="isActive[56]">はい。すべてのコミッション明細（化粧品、ウィッグ等）がWebで確認できます。</dd>
      <dt v-on:click="openInfo('57')" :class="{'is-active': isActive[57]}">支払明細書は自分で印刷できますか？</dt>
      <dd v-show="isActive[57]">
        はい。できます。印刷の手順は以下のとおりです。<br><br>
        メニュー＞ボーナス明細＞対象年月を選ぶ＞「表示する」をクリック＞「ダウンロード」をクリック<br>
        ダウンロードされたファイルを印刷してください。
      </dd>
      <dt v-on:click="openInfo('58')" :class="{'is-active': isActive[58]}">2025年10月以降、紙の明細が欲しい場合どうすればいいですか？</dt>
      <dd v-show="isActive[58]">2025年10月以降、紙の明細（郵送）は有料となります。郵送をご希望の場合は、会員サイトまたはお電話で別途お申込みが必要です。</dd>
      <dt v-on:click="openInfo('59')" :class="{'is-active': isActive[59]}">郵送希望の申込みはどのように行うのですか？</dt>
      <dd v-show="isActive[59]">
        1. 会員サイトから：会員サイト ＞ 設定 ＞ 会員サイト利用設定変更画面よりお申込みください。 <br>
        2. お電話から：弊社サポート窓口（0120-268-510 09:00~17:00 土日祝日休）へお電話にてお申込みください。
      </dd>
      <dt v-on:click="openInfo('60')" :class="{'is-active': isActive[60]}">郵送にかかる費用（手数料）はいくらですか？</dt>
      <dd v-show="isActive[60]">郵送手数料は、<strong>通知書1通につき330円（税込）</strong>です。</dd>
      <dt v-on:click="openInfo('61')" :class="{'is-active': isActive[61]}">郵送手数料はどのように支払うのですか？</dt>
      <dd v-show="isActive[61]">毎月郵送をご希望の方は、郵送手数料を毎月お支払いするコミッションから差し引かせていただきます（相殺）。</dd>
      <dt v-on:click="openInfo('62')" :class="{'is-active': isActive[62]}">手数料がコミッション額より高かった場合、どうなりますか？</dt>
      <dd v-show="isActive[62]">コミッションで相殺しきれなかった分は、次回のコミッションで相殺させていただきます。</dd>
      <dt v-on:click="openInfo('63')" :class="{'is-active': isActive[63]}">一度郵送を申し込むと、いつまで継続されますか？</dt>
      <dd v-show="isActive[63]">お客様ご自身でWeb明細に切り替える手続きをされるまで、毎月継続して郵送されます（都度手数料が発生します）。</dd>
      <dt v-on:click="openInfo('64')" :class="{'is-active': isActive[64]}">月途中で郵送希望に変更した場合、いつから適用されますか？</dt>
      <dd v-show="isActive[64]">変更手続きをされた翌月分からの通知書に適用されます。</dd>
      <dt v-on:click="openInfo('65')" :class="{'is-active': isActive[65]}">紙の通知書は、どのような形式で届きますか？</dt>
      <dd v-show="isActive[65]">A4サイズの書面を封書にてお届けします。</dd>
      <dt v-on:click="openInfo('66')" :class="{'is-active': isActive[66]}">ウィッグの明細のみ郵送を不要にできますか？</dt>
      <dd v-show="isActive[66]">いいえ、区分はできません。明細の郵送を希望された場合、すべての通知書が発行され、それぞれに手数料が発生します。</dd>
      <dt v-on:click="openInfo('67')" :class="{'is-active': isActive[67]}">FAXでの送付は可能ですか？</dt>
      <dd v-show="isActive[67]">申し訳ございませんが、FAXでの送付は行っておりません。会員サイトまたは郵送をご利用ください。</dd>
      <dt v-on:click="openInfo('68')" :class="{'is-active': isActive[68]}">紙の明細を希望していなかったが、印刷できず郵送を依頼したい場合、有料ですか？</dt>
      <dd v-show="isActive[68]">
        はい、<strong>有料（1通330円）</strong>となります。通常はWEB明細なのですが、臨時で郵送を希望する場合、別途手数料が必要です。<br>
        臨時で郵送をご希望の場合は、まずご連絡をいただき、手数料をご確認ください。<br>
        手数料の振込先は以下のとおりです。<br><br>
        【振込先】<br>
        &#9312; 三井住友銀行 浦安支店 (普通) 6769848<br>
        &#9313; ゆうちょ銀行 記号 00160-8 番号 427377<br>
        両金融機関の口座名義 カ) マナビスケショウヒン<br>
        なお、手数料はお客様でご負担ください。
      </dd>
      <dt v-on:click="openInfo('69')" :class="{'is-active': isActive[69]}">過去の通知書を再発行してもらえますか？</dt>
      <dd v-show="isActive[69]">
        はい、過去5年分までWEB明細で閲覧および印刷可能です。<br>
        以下の手順で閲覧してください。<br>
        メニュー＞ボーナス明細＞対象年月を選ぶ＞「表示する」をクリック＞「ダウンロード」をクリック<br>
        ダウンロードされたファイルを印刷してください。<br>
        WEB明細は無料でご利用いただけます。<br><br>
        なお、郵送をご希望の場合、再発行手数料は1通につき330円です。<br>
        まずご連絡をいただき、手数料をご確認ください。<br>
        振込先は以下のとおりです。<br><br>
        【振込先】<br>
        &#9312; 三井住友銀行 浦安支店 (普通) 6769848<br>
        &#9313; ゆうちょ銀行 記号 00160-8 番号 427377<br>
        両金融機関の口座名義 カ) マナビスケショウヒン<br>
        なお、手数料はお客様でご負担ください。
      </dd>
      <dt v-on:click="openInfo('70')" :class="{'is-active': isActive[70]}">Web明細にするとポイントがもらえると聞きましたが？</dt>
      <dd v-show="isActive[70]">WEB明細に切り替えるだけでは、ポイントは付与されません。<br>WEB明細に切り替え、2025年10月以降に前月分コミッションの振込が完了した会員の方に5ポイントが付与されます。</dd>
      <dt v-on:click="openInfo('71')" :class="{'is-active': isActive[71]}">付与されたポイントはいつ、何に使えますか？</dt>
      <dd v-show="isActive[71]">コミッション振込完了後に付与されます。1ポイント＝1円として、商品購入及び匠ワールドの旅行代金にご利用いただけます（商品購入及び匠ワールド以外での利用はできません）。</dd>
      <dt v-on:click="openInfo('72')" :class="{'is-active': isActive[72]}">電話で支給額を教えてもらえますか？</dt>
      <dd v-show="isActive[72]">お電話にて支給額の概算をお答えすることは可能ですが、詳細な明細内容についてのご案内はできかねます。会員サイトをご確認ください。</dd>
      <dt v-on:click="openInfo('73')" :class="{'is-active': isActive[73]}">過去の通知書にも手数料はかかりますか。</dt>
      <dd v-show="isActive[73]">
        はい。郵送をご希望の場合は手数料がかかります。<br>
        まずご連絡をいただき、手数料をご確認ください。<br>
        手数料の振込先は以下のとおりです。<br><br>
        【振込先】<br>
        &#9312; 三井住友銀行 浦安支店 (普通) 6769848<br>
        &#9313; ゆうちょ銀行 記号 00160-8 番号 427377<br>
        両金融機関の口座名義 カ) マナビスケショウヒン<br>
        手数料はお客様でご負担ください。<br><br>
        なお、会員サイトから印刷する場合は手数料はかかりません。
      </dd>
    </dl>
    <h3 class="mt-5 pt-5">ショッピング会員ついて</h3>
    <dl class="list-qa">
        <dt v-on:click="openInfo('15')" :class="{'is-active': isActive[15]}">ショッピング会員とは何ですか。</dt>
        <dd v-show="isActive[15]">ショッピング会員とは、商品購入のみができる会員です。紹介活動はできませんし、コミッションも獲得できません。会員登録には、メンバーズ会員の紹介が必要です。</dd>
        <dt v-on:click="openInfo('16')" :class="{'is-active': isActive[16]}">ショッピング会員からメンバーズ会員に移行できますか。</dt>
        <dd v-show="isActive[16]">はい。以下の条件で移行できます。<br>
          &#9312;紹介者が同じとき<br>
          ショッピング会員と同じ紹介者のものとでメンバーズ会員になるときは、「概要書面」での説明を受けてください。そのうえで「会員資格移行届」を提出してください。ランク、ポイント、購入履歴は移行されます。
          なお、「会員資格移行届」は、会員サポート営業部にご請求ください。<br>
          &#9313;紹介者が異なるとき<br>
          ショッピング会員と異なる紹介者のものとでメンバーズ会員となるときは、ショッピング会員を退会し、その後6カ月経過した後再登録可能です。ランク、ポイントなどはリセットされます。
        </dd>
        <dt v-on:click="openInfo('17')" :class="{'is-active': isActive[17]}">ショッピング会員もアプリは利用できますか。</dt>
        <dd v-show="isActive[17]">いいえ、できません。現在のアプリは「メンバーズ会員専用」です。ショッピング会員の方は、会員サイトからご利用ください。</dd>
        <dt v-on:click="openInfo('18')" :class="{'is-active': isActive[18]}">ショッピング会員もキャンペーンに参加できますか。</dt>
        <dd v-show="isActive[18]">キャンペーンの中にはショッピング会員も参加できるものもあります。詳しくは、各キャンペーンのお知らせをご覧ください。</dd>
        <dt v-on:click="openInfo('19')" :class="{'is-active': isActive[19]}">ショッピング会員もツール品のみの購入はできませんか。</dt>
        <dd v-show="isActive[19]">はい。ショッピング会員もツール品のみの購入はできません。</dd>
        <dt v-on:click="openInfo('21')" :class="{'is-active': isActive[21]}">ショッピング会員も1年購入がないと、非愛用者会員となりますか。</dt>
        <dd v-show="isActive[21]">はい。1年間購入がない場合は非愛用者会員となります。</dd>
        <dt v-on:click="openInfo('22')" :class="{'is-active': isActive[22]}">ショッピング会員は会員サイトから購入するのですか。</dt>
        <dd v-show="isActive[22]">はい。ショッピング会員も会員サイトから購入できます。</dd>
        <dt v-on:click="openInfo('23')" :class="{'is-active': isActive[23]}">ショッピング会員はweb以外からの注文（電話・FAX・銀座サロン・本社）はできますか。</dt>
        <dd v-show="isActive[23]">はい。メンバーズ会員と同じ方法で注文できます。ただし、銀行振込は採用していないのでご注意ください。</dd>
        <dt v-on:click="openInfo('24')" :class="{'is-active': isActive[24]}">商品の追加や修正などの問い合わせ先はどこになりますか。</dt>
        <dd v-show="isActive[24]">会員サポート営業部です。<br>0120-268-510（9:00～17:00 土・日・祝日休）</dd>
        <dt v-on:click="openInfo('25')" :class="{'is-active': isActive[25]}">ショッピング会員の登録の際、ホームページからの登録と書面による登録の両方が必要ですか。</dt>
        <dd v-show="isActive[25]">いいえ。どちらか一方で結構です。得意な方法でご登録ください。</dd>
        <dt v-on:click="openInfo('26')" :class="{'is-active': isActive[26]}">ショッピング会員登録後、FAXで注文する場合、今までと同じ商品注文書でよいでしょうか。</dt>
        <dd v-show="isActive[26]">はい。同じ商品注文書をお使いください。</dd>
        <dt v-on:click="openInfo('27')" :class="{'is-active': isActive[27]}">Vはショッピング会員の代理購入できますか。</dt>
        <dd v-show="isActive[27]">現時点ではできませんが、将来、メンバーズ会員の代理購入の条件が変更となるときに合わせて、ショッピング会員への代理購入を可能にする予定です。しばらくお待ちください。</dd>
        <dt v-on:click="openInfo('28')" :class="{'is-active': isActive[28]}">ショッピング会員用の登録用紙はツール品で購入できますか。</dt>
        <dd v-show="isActive[28]">はい。ツール品で購入できます。10枚1セットで100円（税込）です。</dd>
        <dt v-on:click="openInfo('29')" :class="{'is-active': isActive[29]}">ショッピング会員はスポンサー（紹介者）のマナビス会の人数として数えられますか。</dt>
        <dd v-show="isActive[29]">はい。数えられます。</dd>
        <dt v-on:click="openInfo('30')" :class="{'is-active': isActive[30]}">ショッピング会員がメンバーズ会員に移行する際は実績数1以上の購入は必要ですか。</dt>
        <dd v-show="isActive[30]">いいえ、不要です。手続き方法は「ショッピング会員からメンバーズ会員に移行できますか。」をご覧ください。</dd>
        <dt v-on:click="openInfo('31')" :class="{'is-active': isActive[31]}">メンバーズ会員からショッピング会員への移行は可能ですか。</dt>
        <dd v-show="isActive[31]">はい。可能です。ただし、いくつかの制限があります。<br>
        ・ショッピング会員移行後の購入価格は、最大ユラナス相当分となります。<br>
        ・紹介者が同じ場合、ポイントや注文履歴などはそのまま引き継がれます。<br>
        ・紹介者が異なるときは、メンバーズ会員を退会し、その後6カ月経過した後に再登録可能です。このため、ランク、ポイント、注文履歴などはすべてリセットされます。</dd>
        <dt v-on:click="openInfo('32')" :class="{'is-active': isActive[32]}">ショッピング会員はおまとめ便や代理注文できますか。</dt>
        <dd v-show="isActive[32]">おまとめ便や代理注文は、傘下の方をお世話するための機能なので、ショッピング会員は利用できません。上位の方は、ショッピング会員をおまとめ便の中に含めることはできます。</dd>
        <dt v-on:click="openInfo('33')" :class="{'is-active': isActive[33]}">ショッピング会員の購入の場合も、送料や注文方法、支払方法等のルールはメンバーズ会員と同じですか。</dt>
        <dd v-show="isActive[33]">送料、代金引換手数料は、メンバーズ会員の方と同じです。<br>
        ショッピング会員の方は、銀行振込は利用できません。代金引換または、クレジットカード決済（会員サイトのみ）、現金支払（来店のみ）をご利用いただけます。</dd>
        <dt v-on:click="openInfo('34')" :class="{'is-active': isActive[34]}">メンバーズ会員で、ビジネス活動をしていないためショッピング会員になることは可能でしょうか。</dt>
        <dd v-show="isActive[34]">はい、可能です。ただし、いくつかの制限があります。「メンバーズ会員からショッピング会員への移行は可能ですか。」をご覧ください。</dd>
    </dl>
    <h3 class="mt-5 pt-5">再販売について</h3>
    <dl class="list-qa">
        <dt v-on:click="openInfo('35')" :class="{'is-active': isActive[35]}">再販売とは何ですか。</dt>
        <dd v-show="isActive[35]">メンバーズ会員の方が、非会員の方へ直接マナビス化粧品を販売することです。会員登録は不要です。</dd>
        <dt v-on:click="openInfo('36')" :class="{'is-active': isActive[36]}">再販売の時の価格はいくらですか。</dt>
        <dd v-show="isActive[36]">ファーストランク価格をお勧めしています。</dd>
        <dt v-on:click="openInfo('38')" :class="{'is-active': isActive[38]}">再販売の伝票の保管期限はありますか。</dt>
        <dd v-show="isActive[38]">法的には5年ですが、詳しくは、お知り合いの税理士にご確認ください。</dd>
        <dt v-on:click="openInfo('39')" :class="{'is-active': isActive[39]}">メンバーズ会員から直接購入した商品を返品したいのですが。</dt>
        <dd v-show="isActive[39]">まずは、販売してくださったメンバーズ会員にお問い合わせください。</dd>
        <dt v-on:click="openInfo('40')" :class="{'is-active': isActive[40]}">返品はいつまで受け付けてくださいますか。</dt>
        <dd v-show="isActive[40]">未使用品については、領収書を受け取った日から8日間です。（クーリングオフ）</dd>
        <dt v-on:click="openInfo('41')" :class="{'is-active': isActive[41]}">開封済み商品の返品対応はどのような対応となりますか。</dt>
        <dd v-show="isActive[41]">まずは、販売員（メンバーズ会員）にご相談ください。</dd>
        <dt v-on:click="openInfo('42')" :class="{'is-active': isActive[42]}">再販売した場合、メンバーズ会員は会社に報告は必要ですか。</dt>
        <dd v-show="isActive[42]">会社への報告は不要です。</dd>
        <dt v-on:click="openInfo('43')" :class="{'is-active': isActive[43]}">再販売は、非会員の方を対象としていますが、退会者も可能ですか。非愛用者は再販売できるのでしょうか。</dt>
        <dd v-show="isActive[43]">退会者は非会員なので、再販売可能ですが、非愛用者に対しては、会員なので再販売はできません。</dd>
        <dt v-on:click="openInfo('44')" :class="{'is-active': isActive[44]}">収入印紙はマナビスで購入することはできますか。</dt>
        <dd v-show="isActive[44]">マナビス化粧品では、収入印紙は取り扱っておりません。郵便局などで個人でお買い求めください。</dd>
        <dt v-on:click="openInfo('45')" :class="{'is-active': isActive[45]}">クーリングオフをされた場合に会社より会員への保証はありますか。</dt>
        <dd v-show="isActive[45]">会社からの保証はございません。</dd>
        <dt v-on:click="openInfo('46')" :class="{'is-active': isActive[46]}">再販売する場所というのは直接小売りや自営サロン以外で何が当てはまりますか。楽天やメルカリは該当しますか。</dt>
        <dd v-show="isActive[46]">再販売は、直接販売することです。楽天やメルカリでの販売はご遠慮ください。</dd>
        <dt v-on:click="openInfo('47')" :class="{'is-active': isActive[47]}">再販売をするために会社へ申請は必要ですか。</dt>
        <dd v-show="isActive[47]">会社への申請は不要です。</dd>
        <dt v-on:click="openInfo('48')" :class="{'is-active': isActive[48]}">再販売した際、販売伝票「&#9314;販売者用控え」は会社への提出は必要ですか。</dt>
        <dd v-show="isActive[48]">会社への提出は不要です。販売者（メンバーズ会員）が保管してください。</dd>
        <dt v-on:click="openInfo('49')" :class="{'is-active': isActive[49]}">サロンで展示している商品に掲載されている価格は、何でしょうか。</dt>
        <dd v-show="isActive[49]">サロンで展示している商品は、「ファーストランク価格」を表示しています。</dd>
    </dl>
  </section>
</template>

<script>
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 100; i++) {
        this.isActive[i] = false
    }
  },
  methods: {
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = !this.isActive[ref]
      console.log(this.isActive[ref])
    },
  }
}
</script>